import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { LogoImgDefault } from '../../Files/LogoImgDefault.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { BlockLogoExperiments } from '../../Components/Public/Logos/BlockLogoExperiments.js';
import { BlockEpisode } from '../../Components/Public/Blocks/BlockEpisode.js';
import { BlockTitleDate1Link1 } from '../../Components/Public/Blocks/BlockTitleDate1Link1.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';

export const Experiment = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [experiment, setExperiment] = useState([]);
    useEffect(() => {
        const fetchtheData = async () => {
            const dataExperiment = await fetch(`${backend}/experiment?id=${id}`, GetHeaders(guest));
            const experiment = await dataExperiment.json();
            setExperiment(experiment);
        };
        fetchtheData();
        ScrollTop();
        AnimCarrousel();
    }, [backend, id, guest]);
    const carrouselDatas = CarrouselDatas('experiment', experiment);
    const carrouselTotal = LogoImgDefault('img').length;
    const items = GetDescription('experiment', { experiment: experiment });
    return (
        <div className="character">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="character" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="experiment" />
            <section className="infos">
                {experiment.map((item, i) => {
                    return (
                        <div className="bloc-infos" key={i}>
                            <BlockLogoExperiments label="experiment" item={item} />
                            <BlockEpisode item={item} />
                        </div>
                    )
                })}
                <div className="description">
                    <BlockTitleDate1Link1 label="experiment" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}